module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [(_vm.servicesList.length) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "700px"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.getEditCrewDialog),
      callback: function($$v) {
        _vm.getEditCrewDialog = $$v
      },
      expression: "getEditCrewDialog"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticStyle: {
      "height": "300px"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.approvedTitleLabel))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "disabled": _vm.isPreplan,
      "items": _vm._f("filterPalBearers")(_vm.servicesList),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "label": "Select pallbearers"
    },
    on: {
      "input": _vm.limiter
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")])])]
      }
    }], null, false, 2443514655),
    model: {
      value: (_vm.selectedPallbearersEvent),
      callback: function($$v) {
        _vm.selectedPallbearersEvent = $$v
      },
      expression: "selectedPallbearersEvent"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Select Crew for the funeral")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "disabled": _vm.isPreplan,
      "items": _vm._f("filterPalBearers")(_vm.servicesList, 1),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "label": "Select pallbearers"
    },
    on: {
      "input": _vm.limiter
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")])])]
      }
    }], null, false, 2443514655),
    model: {
      value: (_vm.selectedPallbearersClosing),
      callback: function($$v) {
        _vm.selectedPallbearersClosing = $$v
      },
      expression: "selectedPallbearersClosing"
    }
  }), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "#ff5353",
      "multi-line": "",
      "top": "",
      "right": "",
      "timeout": 6000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n        You can select no more than three\n        "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n          Close\n        ")])], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "gray darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedPallbearersEvent.length || !_vm.selectedPallbearersClosing.length,
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.approvedBtnLabel) + "Select & Notify")])], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a7655bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/CrewDialog.vue
// module id = 942
// module chunks = 1